import readTextColorAndTitle from './readTextColorAndTitle'
export default readTextColorAndTitle
